import React, { useEffect, useState } from "react";
import { api, fmtMoneyShort } from "@/lib/caesar";
import { ScoreRing, ProgressBar, Sparkline } from "@/components/charts";
import { SectionLabel } from "@/components/common";
import { Check, Clock } from "lucide-react";

export default function CommandStrip() {
  const [score, setScore] = useState(null);
  const [rev, setRev] = useState(null);
  const [exec, setExec] = useState(null);

  useEffect(() => {
    api.get("/dashboard/caesar-score").then(({ data }) => setScore(data)).catch(() => {});
    api.get("/dashboard/revenue").then(({ data }) => setRev(data)).catch(() => {});
    api.get("/dashboard/execution").then(({ data }) => setExec(data)).catch(() => {});
  }, []);

  return (
    <div className="grid md:grid-cols-3 gap-4">
      {/* SZR Score */}
      <div className="bg-surface border border-edge rounded-xl p-5">
        <SectionLabel>SZR Score</SectionLabel>
        {score ? (
          <div className="flex items-center gap-4">
            <ScoreRing score={score.score} />
            <div className="text-sm space-y-1 min-w-0">
              <div><span className="label-caps">Strongest</span><div className="text-sgreen font-semibold">{score.strongest || "—"}</div></div>
              <div><span className="label-caps">Needs Attention</span><div className="text-samber font-semibold">{score.needs_attention || "—"}</div></div>
            </div>
          </div>
        ) : <div className="h-[120px]" />}
      </div>

      {/* Revenue goal */}
      <div className="bg-surface border border-edge rounded-xl p-5">
        <SectionLabel>Monthly Revenue Goal</SectionLabel>
        {rev ? (
          <>
            <div className="font-num text-2xl">{fmtMoneyShort(rev.month_progress.value)} <span className="text-[#777] text-base">/ {fmtMoneyShort(rev.month_progress.goal)}</span></div>
            <div className="mt-3"><ProgressBar value={rev.month_progress.value} goal={rev.month_progress.goal} /></div>
            <div className="mt-3 -mx-1"><Sparkline data={rev.series} dataKey="revenue" /></div>
          </>
        ) : <div className="h-[120px]" />}
      </div>

      {/* Daily report status */}
      <div className="bg-surface border border-edge rounded-xl p-5">
        <SectionLabel>Daily Report Status</SectionLabel>
        {exec ? (
          <div className="space-y-2 mt-1">
            {exec.status.map((s) => (
              <div key={s.user_id} className="flex items-center justify-between">
                <span className="text-sm">{s.name}</span>
                {s.submitted
                  ? <span className="inline-flex items-center gap-1 text-xs text-sgreen font-semibold"><Check size={14} /> Submitted</span>
                  : <span className="inline-flex items-center gap-1 text-xs text-samber font-semibold"><Clock size={14} /> Pending</span>}
              </div>
            ))}
            {exec.status.length === 0 && <p className="text-sm text-[#5a5a5a]">No team members yet.</p>}
          </div>
        ) : <div className="h-[120px]" />}
      </div>
    </div>
  );
}
